import { render } from "./MbaPublicAdmin.vue?vue&type=template&id=42d2b1e5"
import script from "./MbaPublicAdmin.vue?vue&type=script&lang=js"
export * from "./MbaPublicAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__